import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BadgeModule } from '../badge/badge.module';
import { DotModule } from '../dot/dot.module';
import { PipesModule } from './../pipes/pipes.module';
import { TabComponent } from './tab/tab.component';
import { TabsComponent } from './tabs.component';

@NgModule({
  declarations: [TabComponent, TabsComponent],
  exports: [TabComponent, TabsComponent],
  imports: [BadgeModule, DotModule, CommonModule, PipesModule],
})
export class TabsModule {}
export { TabComponent } from './tab/tab.component';
export { TabsComponent } from './tabs.component';
